import React from 'react'
import Findbg from "../../../assets/images/DrivingPerson.jpg"
import Shape16 from "../../../assets/images/shape-16.png"
import { config } from '../config'

const FindSection = () => {

    return (
        <div>
            <section className="find-section">
                <div className="bg-layer" style={{ backgroundImage: `url(${Findbg})` }}></div>
                <div className="upper-box">
                    <div className="bg-color"></div>
                    <div className="shape">
                        <div className="shape-1" style={{ backgroundImage: `url(${Shape16})` }}></div>
                    </div>
                    <div className="auto-container">
                        <div className="row clearfix">
                            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                                <div className="content-box">
                                    <div className="sec-title">
                                        <h2>97% of Students <br />Pass Their Driving Test <br />on the First Attempt</h2>
                                    </div>
                                    <p>We take pride in our proven success rate. Our experienced instructors and tailored courses ensure you feel confident and prepared for your driving test. With us, you'll gain the skills you need to ace your test on the first attempt. </p>
                                    <div className="form-group">
                                        <a href={`${config.appUrl}contact-us`}><button type="submit" className="theme-btn btn-two">Send Request</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="lower-box">
                    <div className="bg-color"></div>
                    <Slider {...settings}>
                        {clients?.map((client, i) => {
                            return (
                                <figure className="clients-logo">
                                    <a href="#" key={i}>
                                        <img src={client} alt="" />
                                    </a>
                                </figure>
                            )
                        })}
                    </Slider>
                </div> */}
            </section >
        </div >
    )
}

export default FindSection
